import {ErrorDtoFactory, UpdatePasswordDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as ChangePasswordActions} from "../actions/updatePasswordActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";

export const updateUserPassword = (requestObj: UpdatePasswordDto) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<ChangePasswordActions>) => {
        dispatch({
            type: ActionType.UPDATE_USER_PASSWORD_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/AccountUsers/ResetAccountUserPassword`;
            let result = await axios.post(url, requestObj, config);
            dispatch({
                type: ActionType.UPDATE_USER_PASSWORD_SUCCESS
            })
            dispatch({
                type: ActionType.UPDATE_USER_PASSWORD_COMPLETE
            })
        } catch (err) {
            dispatch({
                type: ActionType.UPDATE_USER_PASSWORD_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}
